export { default } from "./SlicerSponsors"
